/**
 * DRAG & DROP DOS ARQUIVOS
 */
var fileActionSettingsArray = {
    removeIcon: '<i class="ti ti-trash"></i>',
    uploadIcon: '<i class="ti ti-cloud-upload"></i>',
    uploadRetryIcon: '<i class="ti ti-rotate-clockwise"></i>',
    downloadIcon: '<i class="ti ti-download"></i>',
    zoomIcon: '<i class="ti ti-zoom-in"></i>',
    dragIcon: '<i class="ti ti-arrows-move"></i>',
    indicatorNew: '<i class="ti ti-plus-lg text-warning"></i>',
    indicatorSuccess: '<i class="ti ti-check-lg text-success"></i>',
    indicatorError: '<i class="ti ti-exclamation-lg text-danger"></i>',
    indicatorLoading: '<i class="ti ti-hourglass-bottom text-muted"></i>',
    indicatorPaused: '<i class="ti ti-pause-fill text-primary"></i>',
};
var previewZoomButtonIconsArray = {
    prev: '<i class="ti ti-chevron-left"></i>',
    next: '<i class="ti ti-chevron-right"></i>',
    toggleheader: '<i class="ti ti-maximize"></i>',
    fullscreen: '<i class="ti ti-arrows-maximize"></i>',
    borderless: '<i class="ti ti-layout-navbar"></i>',
    close: '<i class="ti ti-x"></i>',
};
function uploadFiles(refresh = false) {
    listaAnexos($("#transacao").val());
    $("#uploadFiles")
        .fileinput({
            language: "pt-BR",
            uploadUrl: "anexos/adicionar",
            uploadAsync: false,
            maxFileCount: 20,
            showClose: false,
            fileActionSettings: fileActionSettingsArray,
            previewZoomButtonIcons: previewZoomButtonIconsArray,
            allowedFileExtensions: ["jpg", "png", "jpeg", "pdf", "doc", "docx", "xls", "xlsx"],
            maxFileSize: 204800,
            uploadExtraData: function () {
                return {
                    transacao: $("#transacao").val(),
                };
            },
        })
        .on("filebatchuploadcomplete", function (event, files, extra) {
            listaAnexos($("#transacao").val());
            $("#uploadFiles").fileinput("clear");
        });
}

function listaAnexos(transacao) {
    $.ajax({
        url: "anexos/listar",
        type: "POST",
        data: {
            transacao: transacao,
        },
        success: function (data) {
            $(".nd-js-lista-anexos").html(data);
        },
    });
}

$(document).on('click', '.btnExcluirAnexo', function (e) {
    e.preventDefault();
    excluirAnexo($(this).attr('data-codigo'), $("#transacao").val());
});

function excluirAnexo(codigo, transacao) {
    Swal.fire({
        theme: document.documentElement.getAttribute('data-bs-theme'),
        title: "Deseja remover realmente?",
        text: "Esta ação irá remover o arquivo anexado na transação!",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d63939",
        confirmButtonColor: "#003177",
        confirmButtonText: "Sim, excluir!",
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                url: "anexos/excluir",
                type: "POST",
                data: {
                    codigo: codigo,
                },
                success: function (result) {
                    result = result.split("|");
                    if (parseInt(result[1]) == 1) {
                        Swal.fire({
                            theme: document.documentElement.getAttribute('data-bs-theme'),
                            title: result[2],
                            icon: "success",
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                        }).then(function (res) {
                            listaAnexos(transacao);
                        });
                    } else {
                        Swal.fire({
                            theme: document.documentElement.getAttribute('data-bs-theme'),
                            text: result[2],
                            icon: "error",
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                        });
                    }
                },
            });
        }
    });
}

$(document).ready(function () {
    $("input, form").attr("autocomplete", "off");
    $('[data-bs-toggle="tooltip"]').tooltip();
    $('[data-bs-toggle="popover"]').popover();
    $(".select-picker").selectpicker({
        style: "btn-default",
    });
});

/** MANTEM A CONEXAO ATIVA */
window.setInterval(function () {
    $.ajax({
        type: "POST",
        url: "keep-logged-in",
        success: function (result) {
            console.log(result);
        },
    });
}, 60000 * 2); // 60 segundos * 2 Minutos

$(document).on("click", ".toggle-password", function () {
    var input = $("#input-password");
    if (input.attr("type") === "password") {
        input.attr("type", "text");
    } else {
        input.attr("type", "password");
    }
});

/**
 * SELECT 2
 */
if ($(".js-select2").length) {
    //select2Init('regioes');
}

if ($(".js-select-midias").length) {
    var settings = {};
    new TomSelect('.js-select-midias', settings);
}

function select2Init(sourceField) {
    var targetData = sourceField.attr("data-id-target");
    console.log(targetData);
    var el = $(".js-select2-" + targetData);
    var refresh = el.attr("data-refresh-target");

    if (refresh == "yes" && el.hasClass("select2-hidden-accessible")) el.select2("destroy");

    el.select2({
        ajax: {
            url: targetData + "/select2",
            dataType: "json",
            method: "post",
            context: this,
            data: function (params) {
                if (targetData == "regioes") {
                    var query = {
                        search: params.term,
                        type: "public",
                        estado: sourceField.val(),
                    };
                } else if (targetData == "cidades-regiao") {
                    var query = {
                        search: params.term,
                        type: "public",
                        regiao: sourceField.val(),
                    };
                }
                // Query parameters will be ?search=[term]&type=public
                return query;
            },
        },
        minimumInputLength: 3,
        placeholder: "Selecione",
        language: {
            errorLoading: function () {
                return "Os resultados não foram ser carregados.";
            },
            searching: function () {
                return "Buscando…";
            },
            noResults: function () {
                return "Nenhum item encontrado";
            },
            inputTooShort: function (args) {
                var remainingChars = args.minimum - args.input.length;
                var message = "Digite " + remainingChars + " ou mais caracteres";
                return message;
            },
        },
    });
}

/**
 * Carrega as cidades de um estado
 */
$(document).on("change", ".load-cidades", function (e) {
    e.preventDefault();

    var target = "#" + $(this).attr("data-id-target");
    var pk = $("option:selected", this).val();

    $(target).html("<option>Carregando ...</option>");
    $.ajax({
        type: "POST",
        data: { estado: pk },
        context: this,
        url: "cidades/select",
        success: function (result) {
            $(target).html(result);
        },
    });
});

/**
 * Carrega as cidades de uma região
 */
$(document).on("change", ".load-cidades-regiao", function (e) {
    e.preventDefault();
    if ($(this).hasClass("js-select2")) {
        select2Init($(this));
    } else {
        var target = "#" + $(this).attr("data-id-target");
        var refresh = $(this).attr("data-refresh-target");
        var pk = $("option:selected", this).val();

        $(target).html("<option>Carregando ...</option>");
        $.ajax({
            type: "POST",
            data: { regiao: pk },
            context: this,
            url: "cidades-regiao/select",
            success: function (result) {
                $(target).html(result);

                if (refresh == "yes") $(".selectpicker").selectpicker("refresh");
            },
        });
    }
});

/**
 * Carrega as regiões de um estado
 */
$(document).on("change", ".load-regioes", function (e) {
    e.preventDefault();
    if ($(this).hasClass("js-select2")) select2Init($(this));
    else {
        var target = "#" + $(this).attr("data-id-target");
        var pk = $("option:selected", this).val();

        $(target).html("<option>Carregando ...</option>");
        $.ajax({
            type: "POST",
            data: { estado: pk },
            context: this,
            url: "regioes/select",
            success: function (result) {
                $(target).html(result);
            },
        });
    }
});

/**
 * Carrega as subcategorias de uma categoria
 */
$(document).on("change", "select.load-subcategorias", function (e) {
    e.preventDefault();
    var target = "#" + $(this).attr("data-id-target");
    $(target).prop("disabled", true);
    var pk = $("option:selected", this).val();
    $.ajax({
        type: "POST",
        data: { categoria: pk },
        context: this,
        url: "subcategorias/select",
        success: function (result) {
            if (result.trim().length == 0) {
                toastFire("1|Categoria sem subcategorias", Toast);
            } else {
                $(target).html(result);
                $(target).prop("disabled", false);
                $(target).selectpicker("destroy");
                $(".select-picker").selectpicker({
                    style: "btn-default",
                    actionsBox: true,
                });
            }
        },
    });
});

/**
 * ATIVO INATIVO NAS LISTAS DE REGISTROS
 * Uso:
 * <label class="form-check form-switch mb-0 d-inline-block">
 *     <input class="form-check-input form-ativo" name="ativo" value="S" data-tipo="segmento" data-codigo="<?php echo md5($row['codigo']); ?>" type="checkbox" <?php echo ($row['ativo']=='S') ? 'checked' : ''; ?> >
 * </label>
 */
$(".form-ativo").change(function () {
    var tipo = $(this).attr("data-tipo") + "/situacao";
    var codigo = $(this).attr("data-codigo");
    var novo_valor = "";
    if (this.checked) {
        novo_valor = "S";
        $(this).prop("checked", true);
    } else {
        $(this).prop("checked", false);
        novo_valor = "";
    }

    $.ajax({
        type: "POST",
        url: tipo,
        context: this,
        data: { codigo: codigo, valor: novo_valor, acao: tipo },
        success: function (result) {
            //$('.row-images-cards').html(result);
        },
    });
});

/**
 * ALERTA RAPIDO TOP RIGHT
 */
const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
});

function toastFire(response, Toast) {
    response = response.split("|");
    Toast.fire({
        icon: response[1] == 1 ? "success" : "error",
        title: response[2],
    });
    return true;
}


/**
 * X-EDITABLE
 */
function startXEditable() {
    if ($(".textDisable").length) {
        $(".textDisable").editable({
            showbuttons: false,
            placement: "left",
            inputclass: "input-disabled",
            tpl: "<textarea readonly></textarea>",
        });
    }

    if ($(".upd-text").length) {
        $(".upd-text").editable({
            tpl: '<input type="text" class="form-control">',
            emptytext: "Editar",
            success: function (response, newValue) {
                toastFire(response, Toast);
                if ($(this).editable().data("refresh")) {
                    location.reload();
                }
            },
        });
    }

    if ($(".upd-textarea").length) {
        $(".upd-textarea").editable({
            emptytext: "Editar",
            inputclass: "form-control",
            success: function (response, newValue) {
                toastFire(response, Toast);
                if ($(this).editable().data("refresh")) {
                    location.reload();
                }
            },
        });
    }

    if ($(".upd-decimal").length) {
        $(".upd-decimal").editable({
            tpl: '<input type="text" class="form-control">',
            emptytext: "Editar",
            inputclass: "maskDecimal",
            success: function (response, newValue) {
                toastFire(response, Toast);
                if ($(this).editable().data("refresh")) {
                    location.reload();
                }
            },
        });
    }

    if ($(".upd-date").length) {
        $(".upd-date").editable({
            emptytext: "Editar",
            format: "yyyy-mm-dd",
            viewformat: "dd/mm/yyyy",
            datepicker: {
                weekStart: 0,
            },
            clear: '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-calendar-event" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><rect x="4" y="5" width="16" height="16" rx="2"></rect><line x1="16" y1="3" x2="16" y2="7"></line><line x1="8" y1="3" x2="8" y2="7"></line><line x1="4" y1="11" x2="20" y2="11"></line><rect x="8" y="15" width="2" height="2"></rect></svg> Hoje',
            success: function (response, newValue) {
                toastFire(response, Toast);
                if ($(this).editable().data("refresh")) {
                    location.reload();
                }
            },
        });
    }

    if ($(".upd-select").length) {
        $(".upd-select").editable({
            emptytext: "Editar",
            mode: "popup",
            inputclass: "form-select",
            success: function (response, newValue) {
                toastFire(response, Toast);
                if ($(this).editable().data("refresh")) {
                    location.reload();
                }
            },
        });

        $(".upd-select").on("save", function (e, params) {
            console.log("Saved value: " + params.newValue);
        });
    }

    if ($(".upd-checklist").length) {
        $(".upd-checklist").editable({
            emptytext: "Editar",
            mode: "popup",
            success: function (response, newValue) {
                toastFire(response, Toast);
                if ($(this).editable().data("refresh")) {
                    location.reload();
                }
            },
        });

        $(".upd-checklist").on("save", function (e, params) {
            console.log("Saved value: " + params.newValue);
        });
    }

    if ($(".upd-ativo").length) {
        $(".upd-ativo").editable({
            mode: "popup",
            success: function (response, newValue) {
                if (newValue === "N") {
                    $(this).removeClass("label-success").addClass("label-danger");
                } else {
                    $(this).removeClass("label-danger").addClass("label-success");
                }
                toastFire(response, Toast);
                if ($(this).editable().data("refresh")) {
                    location.reload();
                }
            },
        });
    }
}
startXEditable();

/**
 * MODAL
 */
$(document).on("click", ".btn-modal", function (e) {
    e.preventDefault();
    var modal = $(this).attr("href");
    var codigo = $(this).attr("data-codigo");
    $.post(modal, { codigo: codigo }, function (resultado) {
        $("body").append(resultado);
        $("#modal").modal("show");

        $("#modal").on("shown.bs.modal", function (e) {
            startXEditable();
            if ($("#uploadFiles").length) uploadFiles();
        });

        $("#modal").on("hidden.bs.modal", function (e) {
            $("#modal").remove();
        });
    });
});

// Pega o maior valor de z-index no DOM
function getMaxZIndex() {
    return Math.max(
        ...Array.from(document.querySelectorAll("body *"), (el) => parseFloat(window.getComputedStyle(el).zIndex)).filter((zIndex) => !Number.isNaN(zIndex)),
        0
    );
}

/**
 * OFFCANVAS
 */
$(document).on("click", ".btn-offcanvas", function (e) {
    e.preventDefault();
    $("#offcanvas").offcanvas("hide");
    var offcanvas = $(this).attr("href");
    var codigo = $(this).attr("data-codigo");
    $.post(offcanvas, { codigo: codigo }, function (resultado) {
        $("body").append(resultado);

        $("#offcanvas").offcanvas("show");
        $(".offcanvas-backdrop").css("z-index", getMaxZIndex() + 1);
        $("#offcanvas").css("z-index", getMaxZIndex() + 2);

        $("#offcanvas").on("shown.bs.offcanvas", function (e) {
            startXEditable();
            $('[data-bs-toggle="tooltip"]').tooltip();
        });

        $("#offcanvas").on("hidden.bs.offcanvas", function (e) {
            $("#offcanvas").remove();
        });
    });
});

/**
 * BOTAO DE EXCLUSAO PADRAO
 */
$(document).on("click", ".btnExcluirDefault", function (e) {
    e.preventDefault();
    var page = $(this).attr("href");
    confirmaExcluir(page, $(this).attr("data-codigo"));
});

$(document).ready(function () {
    // Nova pergunta
    $('#btnNovaPergunta').on('click', function () {
        $('#formPergunta')[0].reset();
        $('#codigo').val('');
        $('#modalPergunta .modal-title').text('Cadastrar Pergunta');
        $('#modalPergunta').modal('show');
    });

    // Editar pergunta
    $('.btnEditarPergunta').on('click', function (e) {
        e.preventDefault();
        const codigo = $(this).data('codigo');

        $.get('perguntas-midias/buscar/' + codigo, function (data) {
            if (data.success) {
                $('#codigo').val(data.pergunta.codigo);
                $('#pergunta').val(data.pergunta.pergunta);
                $('#modalPergunta .modal-title').text('Editar Pergunta');
                $('#modalPergunta').modal('show');
            } else {
                alert('Erro ao carregar pergunta');
            }
        }, 'json');
    });

    // Enviar formulário por AJAX
    $('#formPergunta').on('submit', function (e) {
        e.preventDefault();
        const formData = $(this).serialize();

        $.post('perguntas-midias/salvar', formData, function (data) {
            if (data.success) {
                location.reload();
            } else {
                alert('Erro: ' + data.message);
            }
        }, 'json');
    });
});

$(function () {
    if ($("#sortable").length) {
        $("#sortable").sortable({
            placeholder: "ui-state-highlight",
            update: function (event, ui) {
                let ordem = [];

                $('#sortable tr').each(function (index) {
                    let codigo = $(this).data('codigo');
                    ordem.push({
                        codigo: codigo,
                        ordem: index + 1 // começa do 1
                    });
                });

                // AJAX para enviar a nova ordem ao servidor
                $.ajax({
                    url: 'perguntas-midias/ordenar', // Mude isso para o seu endpoint real
                    method: 'POST',
                    data: { ordem: ordem },
                    success: function (response) {
                        console.log('Ordem atualizada com sucesso.');
                        // Atualize visualmente os números, se necessário
                        $('#sortable tr').each(function (index) {
                            $(this).find('td[data-label="Ordem"]').text(index + 1);
                        });
                    },
                    error: function () {
                        alert('Erro ao atualizar a ordem.');
                    }
                });
            }
        });

        $("#sortable").disableSelection(); // previne seleção de texto durante drag
    }
});


const inputSenha = document.getElementById('senha');
const toggleSenha = document.getElementById('toggleSenha');
const gerarSenha = document.getElementById('gerarSenha');

if (inputSenha && toggleSenha && gerarSenha) {
    
    toggleSenha.addEventListener('click', () => {
        const isPassword = inputSenha.type === 'password';
        inputSenha.type = isPassword ? 'text' : 'password';
        toggleSenha.innerHTML = isPassword ? '<i class="ti ti-eye-off"></i>' : '<i class="ti ti-eye"></i>';
    });

    
    gerarSenha.addEventListener('click', () => {
        const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
        let senha = "";
        for (let i = 0; i < 12; i++) {
            senha += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        inputSenha.value = senha;
        inputSenha.type = 'text';
        toggleSenha.innerHTML = '<i class="ti ti-eye-off"></i>';
    });
}
// FORMULARIO PADRAO
$("#formDefault").validate({
    errorClass: "is-invalid", // Classe para campos inválidos
    validClass: "is-valid", // Classe para campos válidos\
    errorPlacement: function (error, element) {
        let message = error.text();
        const $wrapper = element.hasClass("select-picker") ? element.closest(".bootstrap-select") : element;

        // Aplica como tooltip
        $wrapper
            .attr("data-bs-toggle", "tooltip")
            .attr("data-bs-placement", "top")
            .attr("data-bs-trigger", "hover")
            .attr("title", message)
            .tooltip("dispose") // remove tooltip antiga
            .tooltip(); // mostra tooltip

        // Marca visualmente como inválido
        element.addClass("is-invalid");
        if (element.hasClass("select-picker")) {
            $wrapper.addClass("is-invalid");
        }
    },
    highlight: function (element) {
        const $wrapper = $(element).hasClass("select-picker") ? $(element).closest(".bootstrap-select") : $(element);

        $(element).addClass("is-invalid").removeClass("is-valid");
        $wrapper.addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element) {
        const $wrapper = $(element).hasClass("select-picker") ? $(element).closest(".bootstrap-select") : $(element);

        $(element).removeClass("is-invalid").addClass("is-valid");
        $wrapper.removeClass("is-invalid").addClass("is-valid");
        $wrapper.tooltip("dispose"); // remove tooltip
    },
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                Swal.fire({
                    theme: document.documentElement.getAttribute('data-bs-theme'),
                    title: "Salvando ...",
                    allowOutsideClick: false,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
            },
            success: function (result) {
                result = result.split("|");
                if (parseInt(result[1]) == 1) {
                    Swal.fire({
                        theme: document.documentElement.getAttribute('data-bs-theme'),
                        title: result[2],
                        icon: "success",
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(function (res) {
                        location.reload();
                    });
                } else {
                    Swal.fire({
                        theme: document.documentElement.getAttribute('data-bs-theme'),
                        text: result[2],
                        icon: "error",
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                }
            },
        });
    },
});

/**
 * MASCARAS DE CAMPOS
 */
$(document).on("focus", ".maskHora", function () {
    $(".maskHora").mask("00:00");
});
$(document).on("focus", ".maskDataHora", function () {
    $(".maskDataHora").mask("00/00/0000 00:00");
});
$(document).on("focus", ".maskData", function () {
    $(".maskData").mask("00/00/0000", { reverse: true });
});
$(document).on("focus", ".maskCEP", function () {
    $(".maskCEP").mask("00000-000", { reverse: true });
});
$(document).on("focus", ".maskValor", function () {
    var mask = "000.000,00";
    var maxlength = $(this).attr("maxlength");
    if (maxlength != "") {
        mask = mask.substr(maxlength * -1);
    }
    $(".maskValor").mask(mask, { reverse: true });
});
$(document).on("focus", ".maskDecimal", function () {
    var mask = "00.000.000,00";
    var maxlength = $(this).attr("maxlength");
    if (maxlength != "") {
        mask = mask.substr(maxlength * -1);
    }
    $(".maskDecimal").mask(mask, { reverse: true });
});
$(document).on("focus", ".maskNumber", function () {
    var mask = "0000";
    var maxlength = $(this).attr("maxlength");
    if (maxlength != "") {
        mask = mask.substr(maxlength * -1);
    }
    $(".maskNumber").mask(mask, { reverse: true });
});

$(document).on("focus", ".maskCPF", function () {
    $(".maskCPF").mask("000.000.000-00", { reverse: true });
});
$(document).on("focus", ".maskCNPJ", function () {
    $(".maskCNPJ").mask("00.000.000/0000-00", { reverse: true });
});

function aplicarMascaraCPFCNPJ() {
    var tipoPessoa = $("#pessoa").val();
    var campoDocumento = $("#cpf_cnpj");
    var campoRazaoSocial = $("#razao_social");
    var labelInscricaoEstadual = $(".nd-js-inscricao-estadual");
    var labelCpfCnpj = $(".nd-js-cpf-cnpj");

    // Remove qualquer máscara aplicada antes de adicionar uma nova
    campoDocumento.unmask();

    if (tipoPessoa === "F") {
        campoDocumento.mask("000.000.000-00", { reverse: true }); // CPF
        campoRazaoSocial.prop("disabled", true).val(""); // Desabilita e limpa campo
        labelInscricaoEstadual.text("RG");
        labelCpfCnpj.text("CPF");
    } else if (tipoPessoa === "J") {
        campoDocumento.mask("00.000.000/0000-00", { reverse: true }); // CNPJ
        campoRazaoSocial.prop("disabled", false); // Habilita o campo Nome Fantasia
        labelInscricaoEstadual.text("Inscrição estadual");
        labelCpfCnpj.text("CNPJ");
    }
}
// Aplica a máscara ao carregar a página e ao mudar o select
aplicarMascaraCPFCNPJ();
$("#pessoa").on("change", aplicarMascaraCPFCNPJ);

$(document).on("focus", ".maskTelefone", function () {
    var TelefoneMaskBehavior = function (val) {
            return val.replace(/\D/g, "").length === 11 ? "(99) 00000-0000" : "(99) 0000-00009";
        },
        spOptions = {
            onKeyPress: function (val, e, field, options) {
                field.mask(TelefoneMaskBehavior.apply({}, arguments), options);
            },
        };
    $(".maskTelefone").mask(TelefoneMaskBehavior, spOptions);
});

jQuery.validator.addMethod("cpfValida", function (value, element) {
    return this.optional(element) || validaCPF(value);
}, "Digite um CPF válido");

function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

function validaCPF(CPF) {
    var erro = 0;
    var Soma;
    var Resto;
    var strCPF = CPF.replace(/[^\d]+/g, "");
    Soma = 0;
    if (strCPF == "00000000000" ||
        strCPF == "11111111111" ||
        strCPF == "22222222222" ||
        strCPF == "33333333333" ||
        strCPF == "44444444444" ||
        strCPF == "55555555555" ||
        strCPF == "66666666666" ||
        strCPF == "77777777777" ||
        strCPF == "88888888888" ||
        strCPF == "99999999999")
        return false;
    if (strCPF.length !== 11) return false;
    for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;
    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) erro = 1;
    Soma = 0;
    for (i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;
    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) erro = 1;
    if (erro == 0) {
        return true;
    } else {
        return false;
    }
}

function validaCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj == '') return false;
    if (cnpj.length != 14)
        return false;
    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999")
        return false;
    // Valida DVs
    tamanho = cnpj.length - 2
    numeros = cnpj.substring(0, tamanho);
    digitos = cnpj.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
        return false;
    return true;
}

function somenteNumeros(e) {
    var charCode = e.charCode ? e.charCode : e.keyCode;
    // charCode 8 = backspace
    // charCode 9 = tab
    if (charCode != 8 && charCode != 9) {
        // charCode 48 equivale a 0
        // charCode 57 equivale a 9
        if (charCode < 48 || charCode > 57) {
            return false;
        }
    }
}

function confirmaExcluir(pUrl, pCodigo, pRowPrefix) {
    var row = (pRowPrefix) ? pRowPrefix : 'row';
    Swal.fire({
        theme: document.documentElement.getAttribute('data-bs-theme'),
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover todas as informações relacionadas a este registro!",
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#003177',
        confirmButtonText: 'Sim, excluir!'
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                type: "POST",
                data: {codigo: pCodigo}, //pCodido em md5()
                url: pUrl,
                success: function (response) {
                    result = response.split('|');
                    console.log(pCodigo, response, result);
                    if (parseInt(result[1]) == 1) {
                        $('#' + row + pCodigo).remove();
                        toastFire(response, Toast);
                        if (result[3] == 'refresh') location.reload();
                    } else {
                        Swal.fire({
                            theme: document.documentElement.getAttribute('data-bs-theme'),
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        } 
    });
}

function DecimalUSAtoBR(dado, precisao = 2) {
    if (dado !== undefined && dado !== null && dado !== '') {
        return Number(dado).toLocaleString('pt-BR', { minimumFractionDigits: precisao, maximumFractionDigits: precisao });
    }
    return dado;
}

function DecimalBRtoUSA(dado) {
    if (dado !== undefined && dado !== null && dado.trim() !== '') {
        dado = dado.replace(/\./g, "").replace(",", ".");
        return parseFloat(dado);
    }
    return dado;
}

function setFaviconFromTheme() {
      // Captura o valor do atributo data-bs-theme-primary do <html>
      const cor = document.documentElement.getAttribute('data-bs-theme-primary') || 'blue';
      const tamanho = 32;
      const raio = 8;

      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = tamanho;
      const ctx = canvas.getContext('2d');

      ctx.clearRect(0, 0, tamanho, tamanho);

      // Desenha a bolinha no centro com a cor do tema
      ctx.beginPath();
      ctx.arc(tamanho / 2, tamanho / 2, raio, 0, 2 * Math.PI);
      ctx.fillStyle = cor;
      ctx.fill();

      // Cria/atualiza o favicon
      const favicon = document.querySelector("link[rel='icon']") || document.createElement('link');
      favicon.rel = 'icon';
      favicon.href = canvas.toDataURL('image/png');
      document.head.appendChild(favicon);
}
    window.onload = setFaviconFromTheme;
$("#formLogin").validate({
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                Swal.fire({
                    theme: document.documentElement.getAttribute('data-bs-theme'),
                    icon: "info",
                    title: "Aguarde",
                    html: "Estamos validando o seu acesso.",
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
            },
            success: function (resultado) {
                result = resultado.split("|");
                if (parseInt(result[1]) == 1) {
                    Swal.fire({
                        theme: document.documentElement.getAttribute('data-bs-theme'),
                        icon: "success",
                        title: result[2],
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(function (res) {
                        location.href = "dashboard";
                    });
                } else {
                    Swal.fire({
                        theme: document.documentElement.getAttribute('data-bs-theme'),
                        icon: "error",
                        text: result[2],
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                }
            },
        });
    },
});

if ($('#btnMostrarCadastro').length) {

    document.getElementById('btnMostrarCadastro').addEventListener('click', function (e) {
        e.preventDefault();
        document.getElementById('formLogin').classList.add('d-none');
        document.getElementById('formGeraSenha').classList.add('d-none');
        document.getElementById('formCadastro').classList.remove('d-none');
    });

    document.getElementById('btnEsqueceuSenha').addEventListener('click', function (e) {
        e.preventDefault();
        document.getElementById('formLogin').classList.add('d-none');
        document.getElementById('formCadastro').classList.add('d-none');
        document.getElementById('formGeraSenha').classList.remove('d-none');
    });

    document.querySelectorAll('.btnVoltarLogin').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            document.getElementById('formGeraSenha').classList.add('d-none');
            document.getElementById('formCadastro').classList.add('d-none');
            document.getElementById('formLogin').classList.remove('d-none');
        });
    });
}


function alteraPermissao(codigo, valor, tipo) {
    $.ajax({
        type: "POST",
        url: 'permissoes/situacao',
        context: this,
        data: { codigo: codigo, valor: valor, tipo: tipo },
        success: function (response) {
            result = response.split('|');
            toastFire(response, Toast);
            verificaCheckboxModulo();
        }
    });
}

$('.form-permissoes').change(function () {
    var tipo = $(this).attr('data-tipo');
    var codigo = $(this).attr('data-codigo');
    var valor = '';
    if (this.checked) {
        valor = 'S';
        $(this).prop("checked", true);
    } else {
        $(this).prop("checked", false);
        valor = '';
    }

    alteraPermissao(codigo, valor, tipo);
});


$('.form-modulo').change(function () {
    var modulo = $(this).attr('data-modulo-nome');
    if ($(this).is(':checked')) {
        $('input[type="checkbox"][data-modulo="' + modulo + '"]').prop('checked', true);
        console.log(1);
    } else {
        $('input[type="checkbox"][data-modulo="' + modulo + '"]').prop('checked', false);
        console.log(2);
    }

    $('input[type="checkbox"][data-modulo="' + modulo + '"]').each(function (i, o) {
        var tipo = $(this).attr('data-tipo');
        var codigo = $(this).attr('data-codigo');
        var valor = '';

        if ((this).checked) {
            valor = 'S';
            $(this).prop("checked", true);
        } else {
            $(this).prop("checked", false);
            valor = '';
        }
        alteraPermissao(codigo, valor, tipo);
    });
});

function verificaCheckboxModulo() {
    $('input[type="checkbox"][data-modulo-nome]').each(function (i, o) {
        var modulo = $(this).attr('data-modulo-nome');

        var numberOfChecked = $('input[type="checkbox"][data-modulo="' + modulo + '"]:checked').length;
        var totalCheckboxes = $('input[type="checkbox"][data-modulo="' + modulo + '"]').length;
        var numberNotChecked = totalCheckboxes - numberOfChecked;

        if (numberNotChecked == 0) {
            $(this).prop("checked", true);
        } else {
            $(this).prop("checked", false);
        }
    });
}

verificaCheckboxModulo();
/**/
$(document).on('click', '.btnEnviaSenhaUsuario', function (e) {
    e.preventDefault();
    var email = $(this).attr('data-email');

    Swal.fire({
        title: 'Deseja enviar e-mail para criar a senha?',
        text: "Esta ação irá enviar um email para o usuário para criar a senha de acesso!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#003177',
        confirmButtonText: 'Sim, enviar!'
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                type: "POST",
                data: { 'email-pass': email, acao: 'email-pass', tipo: 'nova' },
                url: "mail-nova-senha",
                success: function (result) {
                    result = result.split('|');
                    console.log(result);
                    if (parseInt(result[1]) == 1) {
                        Swal.fire({
                            html: result[2],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    } else {
                        Swal.fire({
                            text: result[2],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});

$(document).on('click', '#btnSalvarSenhaJurado', function (e) {
    e.preventDefault();
    var codigo = $('#codigoJuradoSenha').val();
    var pass = $('#senha').val();
    if (pass.trim() == '') {
        $('#senha').addClass('is-invalid').focus();
        $('#senha').on('input', function () {
            $(this).removeClass('is-invalid');
        });
        return;
    } else {
        Swal.fire({
            title: 'Deseja alterar a senha do jurado?',
            text: "Lembre-se de enviar a nova senha para ele!",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            cancelButtonColor: '#d63939',
            confirmButtonColor: '#003177',
            confirmButtonText: 'Sim, alterar!'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    type: "POST",
                    data: { 'pass': pass, codigo: codigo },
                    url: "cadastro-jurado/alterar_senha",
                    success: function (result) {
                        result = result.split('|');
                        console.log(result);
                        if (parseInt(result[1]) == 1) {

                            $('#senha').val('').blur();
                            Swal.fire({
                                html: result[2],
                                icon: 'success',
                                timer: 3000,
                                showConfirmButton: false,
                                allowOutsideClick: false
                            });
                        } else {
                            Swal.fire({
                                text: result[2],
                                icon: 'error',
                                timer: 3000,
                                showConfirmButton: false,
                                allowOutsideClick: false
                            });
                        }
                    }
                });
            }
        });
    }
});


$("#formGeraSenha").validate({
    errorClass: "is-invalid", // Classe para campos inválidos
    validClass: "is-valid", // Classe para campos válidos\
    errorPlacement: function (error, element) {
        let message = error.text();
        const $wrapper = element;

        // Aplica como tooltip
        $wrapper
            .attr("data-bs-toggle", "tooltip")
            .attr("data-bs-placement", "top")
            .attr("data-bs-trigger", "hover")
            .attr("title", message)
            .tooltip("dispose") // remove tooltip antiga
            .tooltip(); // mostra tooltip
    },
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                Swal.fire({
                    theme: document.documentElement.getAttribute('data-bs-theme'),
                    title: "Enviando ...",
                    allowOutsideClick: false,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
            },
            success: function (result) {
                result = result.split("|");
                if (parseInt(result[1]) == 1) {
                    Swal.fire({
                        theme: document.documentElement.getAttribute('data-bs-theme'),
                        html: result[2],
                        icon: "success",
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(function (res) {
                        location.reload();
                    });
                } else {
                    Swal.fire({
                        theme: document.documentElement.getAttribute('data-bs-theme'),
                        text: result[2],
                        icon: "error",
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                }
            },
        });
    },
});

/*
rules: {
        novasenha: {
            required: true,
            minlength: 8
        },
        confirmasenha: {
            required: true,
            minlength: 8,
            equalTo: "#novasenha"
        },
    },
    messages: {
        novasenha: {
            required: "Informe uma senha",
            minlength: "A senha deve ter pelo menos 8 caracteres"
        },
        confirmasenha: {
            required: "Informe uma senha",
            minlength: "A senha deve ter pelo menos 8 caracteres",
            equalTo: "As senhas informadas não são iguais"
        }
    },
*/
$(document).on('click', '#formSenha .btnSave', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    if (form.smkValidate()) {
        //SUBMIT form
        if ($('#novasenha').val() === $('#confirmasenha').val()) {
            $(form).ajaxSubmit({
                beforeSubmit: function () {
                    btn.html('<span class="spinner-border spinner-border-sm mr-2" role="status"></span> Salvando ...').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    console.log(result);
                    if (parseInt(result[0]) == 1) {
                        Swal.fire({
                            theme: document.documentElement.getAttribute('data-bs-theme'),
                            title: result[1],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            $("input[type='password']").val('');
                            btn.html(btnTextoOriginal).attr('disabled', false);
                        });
                    } else {
                        Swal.fire({
                            theme: document.documentElement.getAttribute('data-bs-theme'),
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            btn.html(btnTextoOriginal).attr('disabled', false);
                        });
                    }
                }
            });
        } else {
            Swal.fire({
                theme: document.documentElement.getAttribute('data-bs-theme'),
                text: 'As senhas não são iguais!',
                icon: 'error',
                timer: 3000,
                showConfirmButton: false,
                allowOutsideClick: false
            }).then(function (res) {
                btn.html(btnTextoOriginal).attr('disabled', false);
            });
        }
    }
});

$("#formNovaSenha").validate({
    errorClass: "is-invalid", // Classe para campos inválidos
    validClass: "is-valid", // Classe para campos válidos\
    errorPlacement: function (error, element) {
        let message = error.text();
        const $wrapper = element;

        // Aplica como tooltip
        $wrapper
            .attr("data-bs-toggle", "tooltip")
            .attr("data-bs-placement", "top")
            .attr("data-bs-trigger", "hover")
            .attr("title", message)
            .tooltip("dispose") // remove tooltip antiga
            .tooltip(); // mostra tooltip
    },
    rules: {
        novasenha: {
            required: true,
            minlength: 8
        },
        confirmasenha: {
            required: true,
            equalTo: "#novasenha"
        },
    },
    messages: {
        novasenha: {
            required: "Informe uma senha",
            minlength: "A senha deve ter pelo menos 8 caracteres"
        },
        confirmasenha: {
            required: "Informe uma senha",
            minlength: "A senha deve ter pelo menos 8 caracteres",
            equalTo: "As senhas informadas não são iguais"
        }
    },
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                Swal.fire({
                    theme: document.documentElement.getAttribute('data-bs-theme'),
                    title: "Enviando ...",
                    allowOutsideClick: false,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
            },
            success: function (result) {
                result = result.split("|");
                if (parseInt(result[1]) == 1) {
                    Swal.fire({
                        theme: document.documentElement.getAttribute('data-bs-theme'),
                        title: result[2],
                        icon: "success",
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(function (res) {
                        window.location.href = "./";
                    });
                } else {
                    Swal.fire({
                        theme: document.documentElement.getAttribute('data-bs-theme'),
                        text: result[2],
                        icon: "error",
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                }
            },
        });
    },
});

$("#formCadastro").validate({
    errorClass: "is-invalid", // Classe para campos inválidos
    validClass: "is-valid", // Classe para campos válidos\
    errorPlacement: function (error, element) {
        const message = error.text();

        // Força sempre a remoção do tooltip antigo
        element.removeAttr("data-bs-original-title"); // impede cache de mensagem
        element.tooltip('dispose');

        // Recria tooltip com nova mensagem
        element
            .attr("data-bs-toggle", "tooltip")
            .attr("data-bs-placement", "top")
            .attr("title", message)
            .tooltip({ trigger: "hover" });
    },
    success: function (label, element) {
        const $el = $(element);
        $el.removeAttr("data-bs-original-title");
        $el.tooltip('dispose');
    },
    rules: {
        cpf: {
            required: true,
            cpfValida: true
        },
        senha: {
            required: true,
            minlength: 8
        },
        confirmasenha: {
            required: true,
            minlength: 8,
            equalTo: "#senhaCadastro"
        },
    },
    messages: {
        cpf: {
            required: "Informe o CPF",
            cpfValida: "Digite um CPF válido"
        },
        senha: {
            required: "Informe uma senha",
            minlength: "A senha deve ter pelo menos 8 caracteres"
        },
        confirmasenha: {
            required: "Informe a confirmação da senha",
            minlength: "A senha deve ter pelo menos 8 caracteres",
            equalTo: "As senhas informadas não são iguais"
        }
    },
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                Swal.fire({
                    theme: document.documentElement.getAttribute('data-bs-theme'),
                    title: "Enviando ...",
                    allowOutsideClick: false,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
            },
            success: function (result) {
                result = result.split("|");
                if (parseInt(result[1]) === 1) {
                    Swal.fire({
                        theme: document.documentElement.getAttribute('data-bs-theme'),
                        title: result[2],
                        icon: "success",
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(function (res) {
                        window.location.href = "./";
                    });
                } else if (parseInt(result[1]) === 2) {
                    console.log(3);
                    Swal.fire({
                        theme: document.documentElement.getAttribute('data-bs-theme'),
                        title: result[2],
                        html: result[3],
                        icon: "warning",
                        //timer: 3000,
                        showConfirmButton: true,
                        confirmButtonColor: '#003177',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    })
                    /* .then(function (res) {
                        window.location.href = "./";
                    }); */
                } else {
                    Swal.fire({
                        theme: document.documentElement.getAttribute('data-bs-theme'),
                        text: result[2],
                        icon: "error",
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                }
            },
        });
    },
});

/**
 * ACEITO CONTRATO
 */
$(document).on('click', '.btn-aceito-contrato', function (e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    var sexo = $('#sexoAvaliador option:selected').val();
    var data_nascimento = $('#dataNascimentoAvaliador').val();
    $.ajax({
        type: "POST",
        data: { codigo: codigo, sexo: sexo, data_nascimento: data_nascimento },
        url: 'usuarios/aceito-contrato',
        success: function (response) {
            result = response.split('|');
            console.log(codigo, response, result);
            if (parseInt(result[1]) == 1) {
                Swal.fire({
                    theme: document.documentElement.getAttribute('data-bs-theme'),
                    title: result[2],
                    icon: 'success',
                    timer: 3000,
                    showConfirmButton: false,
                    allowOutsideClick: false
                }).then(function (res) {
                    location.reload();
                });
            } else {
                Swal.fire({
                    theme: document.documentElement.getAttribute('data-bs-theme'),
                    text: result[2],
                    icon: 'error',
                    timer: 3000,
                    showConfirmButton: false,
                    allowOutsideClick: false
                });
            }
        }
    });
});